export const SET_LANGUAGE_DROPDOWN_HIDDEN = "SET_LANGUAGE_DROPDOWN_HIDDEN";
export const SET_SUPPORTED_LOCALES = "SET_SUPPORTED_LOCALES";